
















































































import { Usuario } from '@/models'
import { FindUsuarioUseCase } from '@/usecases/usuario/FindUsuariosUseCase'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { nextTick } from '@/shareds/utils'
import SeletorDeUsuario from '@/components/usuario/SeletorDeUsuario.vue'
import { arrayObrigatorio } from '@/shareds/regras-de-form'

@Component({
	components: {
		SeletorDeUsuario,	
	},
})
export default class DialogoDeFiltroDeRelatorioDeVenda extends Vue {
	@Ref() form!: HTMLFormElement
	@Prop({type: Boolean, default: false}) carregando!: boolean
	@Prop({type: String, default: null}) lojaId!: string

	filtro = {
		vendedor: null,
		condicaoPagamento: ['À vista', 'Parcelado'],
		formaPagamento: ['Cartão', 'Dinheiro', 'Voucher', 'TEF Crédito', 'TEF Débito', 'Outro'],
	}

	findUsuarioUseCase = new FindUsuarioUseCase()
	vendedores: Usuario[] = []

	mostra: boolean | null = null
	arrayObrigatorio = arrayObrigatorio

	mostrar() {
		this.mostra = true
	}

	ocultar(){
		this.mostra = false
	}

	get formaDePagamento() {
		return [
			{text:'Cartão', value:'Cartão'},
			{text:'Dinheiro', value:'Dinheiro'},
			{text:'Voucher', value:'Voucher'},
			{text:'TEF Crédito', value:'TEF Crédito'},
			{text:'TEF Débito', value:'TEF Débito'},
			{text:'Outros', value:'Outro'},
		]
	}

	async aplicarFiltro() {
		if (!this.form.validate()) return
		await nextTick()
		this.$emit('buscar', this.filtro)
	}
}
